export class BaseDtoModel {
  totalRecords: number;
}

export class BaseCriteriaDtoModel {
  status?: string;
  excludedStatuses?: string[];
  limit?: number;
  offset?: number;
  orderBy?: string;
  order?: string;
  calcTotalRecords?: boolean;
  snapshot?: string; 
  search_word?: string;
}